import React from 'react';
import NavBar from '../Components/NavBar';
import CaseStudyHead from '../Components/CaseStudyHead';
import ProjectCards from '../Components/ProjectCards';
import Footer from '../Components/Footer';
import './AppsProjects.css';

const ProjectsPage = () => {
  return (
    <>
      <NavBar />
      <CaseStudyHead topText="Projects" bottomText="Case Study" />
      <section className="bgapps">
        <ProjectCards />
      </section>
      <Footer />
    </>
  );
};

export default ProjectsPage;
